import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

function Category({color, classes = '', url}) {
    const navigate = useNavigate();
    const onMenuClick = () => {
        navigate(`/${url}`);
    }
    return (
        <div className={classes} onClick={onMenuClick}>
            <svg id="menu" xmlns="http://www.w3.org/2000/svg" width="18" height="17.217" viewBox="0 0 18 17.217">
                <path id="menu-2" data-name="menu"
                      d="M4,5V9.7H8.7V5ZM5.565,6.565H7.13V8.13H5.565Zm4.7,0V8.13H22V6.565ZM4,11.261v4.7H8.7v-4.7Zm1.565,1.565H7.13v1.565H5.565Zm4.7,0v1.565H22V12.826ZM4,17.522v4.7H8.7v-4.7Zm1.565,1.565H7.13v1.565H5.565Zm4.7,0v1.565H22V19.087Z"
                      transform="translate(-4 -5)" fill={color}/>
            </svg>
        </div>

    );
}

export default Category;
